// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QoJpV","myClass":"styles_myClass__zSIAO"};